import React, { useState } from 'react';
import donateBoxIcon from '../../assets/donate.png';
import ReactModal from 'react-modal';
import launch from '../../assets/launch.png';
import './releaseNote.scss';
// import Modal from 'https://cdn.skypack.dev/react-modal@3.16.1';
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    width: '80%',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    boxShadow: '1px 2px #888888',
  },
};

function ReleaseNote({ modalIsOpen, setIsOpen, closeModal }) {
  const [showCopy, setshowCopy] = useState(false);
  const copied = () => {
    setshowCopy(true);
    navigator.clipboard.writeText(`hx5b0699827e3731ae468ce3f1bc8ab10ba03a1a22`);
    setTimeout(() => {
      setshowCopy(() => {
        return false;
      });
    }, 1000);
  };
  //reactModal.setAppElement('#yourAppElement');
  return (
    <div className='grid h-screen place-items-center '>
      <ReactModal isOpen={modalIsOpen} onRequestClose={closeModal} style={customStyles}>
        <div className='releaseNote fadeIn_anim'>
          <div className='button'>
            <button
              onClick={closeModal}
              className='button relative left-0 float-right text-red-600 font-bolder text-2xl'
            >
              X
            </button>
          </div>
          <h2 className='title'>Release Notes</h2>
          <div className='body'>Here will be notes from the latest release.</div>
          <div className='date'>25 May, 2023</div>
          <div className='body bold'>Release Note v0.1</div>
          <ol className='featureList'>
            <li>Selected server setup will be saved from users. So they don't have to change it everytime.</li>
            <li>Improved more errors catching feature. </li>
            <li>Debugged minor bugs 🐞 </li>
          </ol>
          {/* <div className='body'>
            After hearing such good praise about the tool, We decided to improve it for better usability and features.
          </div>
          <div className='body'>
            We are also opening a portal for any kind of donations, suggestions or petition{' '}
            <img className='donateBoxIcon' src={donateBoxIcon} alt='' />{' '}
          </div> */}

          <br />
          <div>Send me some Feedback.</div>
          <div
            className='address'
            onClick={() => {
              window.open(
                `https://docs.google.com/forms/d/e/1FAIpQLSdg4MK6SPb9rJZVxkYpKqkjd593YX4jm-2PvG10WCy7TUx5PA/viewform`,
                '_blank'
              );
            }}
          >
            Feedback Form
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default ReleaseNote;
